import { z } from "zod";
import { CustomFormFieldValidation } from "@shared/types";

interface CustomValidations {
  confirmPassword: CustomFormFieldValidation;
}

export const changePasswordSchema = ({ confirmPassword }: CustomValidations) => {
  return z.object({
    password: z.string().min(6),
    confirmPassword: z.string().min(6)
  }).refine((data) => data.password === data.confirmPassword, {
    message: confirmPassword.errorMessage,
    path: ["confirmPassword"],
  });
};

export type ChangePasswordFormValues = z.infer<
  ReturnType<typeof changePasswordSchema>
>;
